import { useNavigate } from "react-router-dom";

import CounsellorsPage from "../AdminDashboard/Counsellors/CounsellorsPage";
import {
  createChannelPartnerCounsellor,
  deleteChannelPartnerCounsellor,
  fetchChannelPartnerCounsellor,
  fetchChannelPartnerCounsellorStats,
  fetchChannelPartnerCounsellors,
  updateChannelPartnerCounsellor,
} from "../../services/channelPartnerPortalApi";
import ChannelPartnerDashboardLayout from "./ChannelPartnerDashboardLayout";

const ChannelPartnerCounsellorsPage = () => {
  const navigate = useNavigate();

  return (
    <CounsellorsPage
      fetchStats={fetchChannelPartnerCounsellorStats}
      fetchItems={fetchChannelPartnerCounsellors}
      createItem={createChannelPartnerCounsellor}
      fetchItem={fetchChannelPartnerCounsellor}
      updateItem={updateChannelPartnerCounsellor}
      deleteItem={deleteChannelPartnerCounsellor}
      onViewItem={(counsellor) => navigate(
        (
          "/channel-partner-portal/counsellors/work?counsellor="
          + counsellor.counsellor_id
        ),
      )}
      layoutComponent={ChannelPartnerDashboardLayout}
    />
  );
};

export default ChannelPartnerCounsellorsPage;
